import React, { useState } from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { FeatureSwitches } from '../../../constants/feature-switches';

export const CPSAnnouncementBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(true);

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner || !FeatureSwitches.enableCPSAnnouncementBanner) return null;
  return (
    <Alert
      status="info"
      size="large"
      onClose={handleClose}
      headline="Check out the new Purchase History features!"
    >
      Effortlessly find your orders or returns by searching by either item
      description, order number, or PO/Job name.
    </Alert>
  );
};
